/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetEncumbrance } from './AssetEncumbrance';
import {
    AssetEncumbranceFromJSON,
    AssetEncumbranceFromJSONTyped,
    AssetEncumbranceToJSON,
    AssetEncumbranceToJSONTyped,
} from './AssetEncumbrance';
import type { AssetPropertyRightKind } from './AssetPropertyRightKind';
import {
    AssetPropertyRightKindFromJSON,
    AssetPropertyRightKindFromJSONTyped,
    AssetPropertyRightKindToJSON,
    AssetPropertyRightKindToJSONTyped,
} from './AssetPropertyRightKind';

/**
 * 
 * @export
 * @interface AssetPropertyRightRequest
 */
export interface AssetPropertyRightRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    id: string | null;
    /**
     * 
     * @type {AssetPropertyRightKind}
     * @memberof AssetPropertyRightRequest
     */
    kind: AssetPropertyRightKind;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    landlord: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightRequest
     */
    isCurrentHome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    propertyDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightRequest
     */
    expectsProceeds: boolean | null;
    /**
     * 
     * @type {AssetEncumbrance}
     * @memberof AssetPropertyRightRequest
     */
    proceedsEncumbrance: AssetEncumbrance | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    encumberedClaimId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightRequest
     */
    isProceedsAmountKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetPropertyRightRequest
     */
    proceedsAmount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetPropertyRightRequest
     */
    proceedsDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    remarks: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    details: string | null;
}



/**
 * Check if a given object implements the AssetPropertyRightRequest interface.
 */
export function instanceOfAssetPropertyRightRequest(value: object): value is AssetPropertyRightRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('landlord' in value) || value['landlord'] === undefined) return false;
    if (!('isCurrentHome' in value) || value['isCurrentHome'] === undefined) return false;
    if (!('propertyDetails' in value) || value['propertyDetails'] === undefined) return false;
    if (!('expectsProceeds' in value) || value['expectsProceeds'] === undefined) return false;
    if (!('proceedsEncumbrance' in value) || value['proceedsEncumbrance'] === undefined) return false;
    if (!('encumberedClaimId' in value) || value['encumberedClaimId'] === undefined) return false;
    if (!('isProceedsAmountKnown' in value) || value['isProceedsAmountKnown'] === undefined) return false;
    if (!('proceedsAmount' in value) || value['proceedsAmount'] === undefined) return false;
    if (!('proceedsDate' in value) || value['proceedsDate'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function AssetPropertyRightRequestFromJSON(json: any): AssetPropertyRightRequest {
    return AssetPropertyRightRequestFromJSONTyped(json, false);
}

export function AssetPropertyRightRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPropertyRightRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kind': AssetPropertyRightKindFromJSON(json['kind']),
        'landlord': json['landlord'],
        'isCurrentHome': json['isCurrentHome'],
        'propertyDetails': json['propertyDetails'],
        'expectsProceeds': json['expectsProceeds'],
        'proceedsEncumbrance': AssetEncumbranceFromJSON(json['proceedsEncumbrance']),
        'encumberedClaimId': json['encumberedClaimId'],
        'isProceedsAmountKnown': json['isProceedsAmountKnown'],
        'proceedsAmount': json['proceedsAmount'],
        'proceedsDate': (json['proceedsDate'] == null ? null : new Date(json['proceedsDate'])),
        'remarks': json['remarks'],
        'details': json['details'],
    };
}

export function AssetPropertyRightRequestToJSON(json: any): AssetPropertyRightRequest {
    return AssetPropertyRightRequestToJSONTyped(json, false);
}

export function AssetPropertyRightRequestToJSONTyped(value?: AssetPropertyRightRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': AssetPropertyRightKindToJSON(value['kind']),
        'landlord': value['landlord'],
        'isCurrentHome': value['isCurrentHome'],
        'propertyDetails': value['propertyDetails'],
        'expectsProceeds': value['expectsProceeds'],
        'proceedsEncumbrance': AssetEncumbranceToJSON(value['proceedsEncumbrance']),
        'encumberedClaimId': value['encumberedClaimId'],
        'isProceedsAmountKnown': value['isProceedsAmountKnown'],
        'proceedsAmount': value['proceedsAmount'],
        'proceedsDate': value['proceedsDate'] == null ? value['proceedsDate'] : `${value['proceedsDate'].getFullYear()}-${String(value['proceedsDate'].getMonth()+1).padStart(2,'0')}-${String(value['proceedsDate'].getDate()).padStart(2,'0')}`,
        'remarks': value['remarks'],
        'details': value['details'],
    };
}

